import React from 'react';
import styles from './top-menu.module.css';

interface Props {
  children: React.ReactNode;
}
export const TopMenu = ({ children }: Props) => {
  return <div className={styles.container}>{children}</div>;
};
